<app-table
    [tableClass]="tableClass"
    [calendar]="calendarTable"
    [btnExport]="btnExport"
    [filterFunnel]="filterFunnel"
    (keyup)="onFilterTextChange($event)">
</app-table>